import {
    BUCKET_SETTINGS_CORS_GET_SUCCESS,
    BUCKET_SETTINGS_CORS_SET_FAILURE,
    BUCKET_SETTINGS_CORS_SET_REQUEST,
    BUCKET_SETTINGS_CORS_SET_SUCCESS,
} from '../constants/types';

export default function lifecycle(state, action) {
    if (!state) {
        return {
            loading: false,
            rules: {},
        };
    }

    switch (action.type) {
        case BUCKET_SETTINGS_CORS_SET_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case BUCKET_SETTINGS_CORS_GET_SUCCESS:
        case BUCKET_SETTINGS_CORS_SET_SUCCESS:
            return {
                ...state,
                loading: false,
                rules: {
                    ...state.rules,
                    [action.bucketName]: action.rules,
                },
            };

        case BUCKET_SETTINGS_CORS_SET_FAILURE:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
}
